export const defaultPageSizeOptions = [15, 30, 60];

export function range(start: number, end: number) {
  const length = end - start + 1;
  return Array.from({ length }, (_, i) => start + i);
}

/**
 * Function to calculate what pages should be shown or hidden in the pagination bar.
 * Based heavily on @material-ui/labs v4:
 * https://github.com/mui/material-ui/blob/v4.x/packages/material-ui-lab/src/Pagination/usePagination.js
 */
export function calculatePagination(totalPages: number, currentPage: number, siblingCount = 1) {
  // Calculate the beginning of pages shown surrounding the currently selected page
  const siblingsStart = Math.max(
    Math.min(
      // Natural start
      currentPage - siblingCount,
      // Lower boundary when page is high (page count - siblings - first and last)
      totalPages - siblingCount * 2 - 2
    ),
    // Greater than startPages
    3
  );

  // End of pages surrounding the currently selected page
  const siblingsEnd = Math.min(
    Math.max(
      // Natural end
      currentPage + siblingCount,
      // Upper boundary when page is low
      1 + siblingCount * 2 + 2
    ),
    // Less than endPages
    totalPages - 2
  );

  return [
    1,
    // Start ellipsis or second page, if needed
    ...(siblingsStart > 3 ? ['startEllipsis'] : 2 < totalPages - 1 ? [2] : []),
    // Sibling and current pages
    ...range(siblingsStart, siblingsEnd),
    // End ellipsis or second to last page, if needed
    ...(siblingsEnd < totalPages - 2 ? ['endEllipsis'] : totalPages - 1 > 1 ? [totalPages - 1] : []),
    // Last page, if not already shown as sibling
    ...(totalPages > siblingsEnd && totalPages > 1 ? [totalPages] : [])
  ];
}
